var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateEmployerWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9991 8.66617C13.656 8.66617 14.9992 7.32299 14.9992 5.6661C14.9992 4.0092 13.656 2.66602 11.9991 2.66602C10.3422 2.66602 8.99902 4.0092 8.99902 5.6661C8.99902 7.32299 10.3422 8.66617 11.9991 8.66617Z",
    stroke: "white",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9993 18.6675H5.99902V17.3341C5.99902 15.7428 6.63118 14.2166 7.75643 13.0914C8.88167 11.9661 10.4078 11.334 11.9992 11.334C13.5905 11.334 15.1167 11.9661 16.2419 13.0914C17.3672 14.2166 17.9993 15.7428 17.9993 17.3341V18.6675Z",
    stroke: "white",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.665 2.66602C17.4607 2.66602 18.2238 2.9821 18.7864 3.54472C19.349 4.10735 19.6651 4.87043 19.6651 5.6661C19.6651 6.46177 19.349 7.22485 18.7864 7.78747C18.2238 8.35009 17.4607 8.66617 16.665 8.66617",
    stroke: "white",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33405 2.66602C6.53839 2.66602 5.77531 2.9821 5.21268 3.54472C4.65006 4.10735 4.33398 4.87043 4.33398 5.6661C4.33398 6.46177 4.65006 7.22485 5.21268 7.78747C5.77531 8.35009 6.53839 8.66617 7.33405 8.66617",
    stroke: "white",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7988 11.5859C19.9346 12.018 20.9125 12.7848 21.6029 13.7848C22.2934 14.7848 22.664 15.9708 22.6656 17.1861V18.6661H20.6655",
    stroke: "white",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20026 11.5859C4.06445 12.018 3.08661 12.7848 2.39614 13.7848C1.70566 14.7848 1.3351 15.9708 1.3335 17.1861V18.6661H3.33354",
    stroke: "white",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateEmployerWhite);
export default __webpack_public_path__ + "static/media/createEmployer_white.7fee190eaa870da2454617a6e11c1740.svg";
export { ForwardRef as ReactComponent };